(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
      
  
  let classes = document.getElementsByClassName("shopify-section")
  document.getElementById("MainContent").classList.add("bg-[#FEF5EA]")
  for(let i=0;i<classes.length;i++){
    classes[i].classList.add("bg-[#FEF5EA]")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // FIX (revamp): replaces the old hardcoded Occasion->Vibe product map
  // (which pointed at two archived products, Mirage and Vigor) with data
  // read from find-my-escent-data, which is rebuilt from live product tags
  // on every page render. Also drops the "Occasion" step entirely, since it
  // never had any real data behind it -- Vibe is now the whole quiz.
  const findMyEscentDataEl = document.getElementById('find-my-escent-data');
  const findMyEscentMatches = findMyEscentDataEl
  ? JSON.parse(findMyEscentDataEl.textContent)
  : { woody: [], citrus: [], floral: [] };

  document.getElementById('option_1').addEventListener('click', () => {
  showFindMyEscentResults('citrus', 'Citrus & Fresh');
  });
  document.getElementById('option_2').addEventListener('click', () => {
  showFindMyEscentResults('floral', 'Gourmand & Floral');
  });
  document.getElementById('option_3').addEventListener('click', () => {
  showFindMyEscentResults('woody', 'Woody & Oud');
  });
  document.getElementById('cross').addEventListener('click', resetFindMyEscent);
  document.getElementById('back_modal').addEventListener('click', resetFindMyEscent);

  function resetFindMyEscent() {
  document.getElementById('back_modal').classList.add('invisible');
  document.getElementById('to_hide').classList.remove('hidden');
  const existingResults = document.getElementById('find_my_escent_results');
  if (existingResults != null) {
  existingResults.remove();
  }
  }

  function showFindMyEscentResults(familyKey, label) {
  document.getElementById('to_hide').classList.add('hidden');
  document.getElementById('back_modal').classList.remove('invisible');

  const existingResults = document.getElementById('find_my_escent_results');
  if (existingResults != null) {
  existingResults.remove();
  }

  const products = findMyEscentMatches[familyKey] || [];

  const results = document.createElement('div');
  results.id = 'find_my_escent_results';
  results.classList.add('flex', 'flex-col', 'justify-center');

  const heading = document.createElement('div');
  heading.classList.add('text-center', 'text-black', 'font-[Manrope]', 'text-[14px]', 'mx-[8px]', 'mt-[8px]');
  heading.innerHTML = products.length
  ? 'Here\'s what suits your <b>' + label + '</b> vibe. 🌲✨'
  : 'Nothing in the <b>' + label + '</b> family right now — check back soon!';
  results.appendChild(heading);

  products.forEach((product) => {
  const row = document.createElement('div');
  row.classList.add(
  'text-[14px]', 'text-center', 'flex', 'items-center', 'justify-between',
  'rounded-[16px]', 'border', 'border-black', 'p-6', 'm-4', 'cursor-pointer'
  );
  if (!product.available) {
  row.classList.add('opacity-60');
  }

  const imageWrap = document.createElement('div');
  imageWrap.classList.add('relative');

  const image = document.createElement('img');
  image.src = product.image;
  image.alt = product.title;
  image.classList.add('h-[77px]', 'aspect-[4/5]', 'rounded-[16px]');
  imageWrap.appendChild(image);

  if (!product.available) {
  const soldOutBadge = document.createElement('span');
  soldOutBadge.textContent = 'Sold out';
  soldOutBadge.classList.add(
  'absolute', 'top-0', 'left-0', 'bg-black', 'text-white',
  'text-[10px]', 'px-2', 'py-0.5', 'rounded-[8px]'
  );
  imageWrap.appendChild(soldOutBadge);
  }
  row.appendChild(imageWrap);

  const name = document.createElement('div');
  name.textContent = product.title;
  name.classList.add('flex', 'items-center');
  row.appendChild(name);

  const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  iconPath.setAttribute(
  'd', 'M9.03055 9.03063L1.53055 16.5306C1.46087 16.6003 1.37815 16.6556 1.2871 16.6933C1.19606 16.731 1.09847 16.7504 0.999929 16.7504C0.901383 16.7504 0.803801 16.731 0.712756 16.6933C0.621712 16.6556 0.538986 16.6003 0.469303 16.5306C0.399621 16.4609 0.344345 16.3782 0.306633 16.2872C0.268921 16.1961 0.249512 16.0986 0.249512 16C0.249512 15.9015 0.268921 15.8039 0.306633 15.7128C0.344345 15.6218 0.399621 15.5391 0.469303 15.4694L7.43962 8.5L0.469303 1.53063C0.328573 1.3899 0.249512 1.19903 0.249512 1.00001C0.249512 0.800982 0.328573 0.610111 0.469303 0.46938C0.610034 0.32865 0.800906 0.249588 0.999929 0.249588C1.19895 0.249588 1.38982 0.32865 1.53055 0.46938L9.03055 7.96938C9.10029 8.03903 9.15561 8.12175 9.19335 8.2128C9.23109 8.30385 9.25052 8.40144 9.25052 8.5C9.25052 8.59857 9.23109 8.69616 9.19335 8.78721C9.15561 8.87826 9.10029 8.96098 9.03055 9.03063Z'
  );
  iconSvg.setAttribute('viewBox', '0 0 10 17');
  iconSvg.appendChild(iconPath);
  iconSvg.classList.add('w-[20px]', 'h-[20px]', 'flex', 'items-center', 'my-auto');
  row.appendChild(iconSvg);

  row.addEventListener('click', () => {
  window.location.href = product.url;
  });

  results.appendChild(row);
  });

  const viewAllLink = document.createElement('a');
  viewAllLink.href = '/pages/find-my-escent';
  viewAllLink.textContent = 'View all recommendations';
  viewAllLink.classList.add('block', 'text-center', 'text-[12px]', 'underline', 'my-4');
  results.appendChild(viewAllLink);

  document.getElementById('page_1').appendChild(results);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
